var map = {
	"./1.png": 16832,
	"./10.png": 63437,
	"./2.png": 13330,
	"./3.png": 42096,
	"./4.png": 78096,
	"./5.png": 34439,
	"./6.png": 70599,
	"./7.png": 68942,
	"./8.png": 30227,
	"./9.png": 74978
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94963;